import jquery from "jquery";
import Widget from "./Widget";
export class List extends Widget {
    constructor(enumerated = false) {
        super(jquery(enumerated ? "<ol>" : "<ul>"));
    }
    item(...appendable) {
        this.append(c("<li></li>").append(...appendable));
        return this;
    }
    sublist(l) {
        let list = new List();
        l(list);
        this.item(list);
        return this;
    }
}
